import { Snackbar } from '@material-ui/core';
import { bind } from 'bind-decorator';
import React from 'react';

interface IProps {
  open?: boolean;

  onClick: (e: React.MouseEvent) => void;
  onClose: () => void;
}

class HelpSnackbar extends React.Component<IProps> {
  static defaultProps: Partial<IProps> = {
    open: false
  };

  render() {
    return (
      <Snackbar
        className="login-help help-snackbar snack-container"
        open={this.props.open}
        action={<span className="login-help help-snackbar actions">Resend</span>}
        bodyStyle={{ height: 100, lineHeight: '20px', padding: 20 }}
        message="We've sent you an email. Please follow the instructions in the email to get logged in."
        onClick={this.onClick}
        onClose={this.onClose}
      />
    );
  }

  @bind
  onClick(e: React.MouseEvent): void {
    this.props.onClick(e);
  }

  @bind
  onClose(): void {
    this.props.onClose();
  }
}

export default HelpSnackbar;
